"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from "react";
import type { ApiWave } from "@/generated/models/ObjectSerializer";
import MemesArtSubmissionModal from "../MemesArtSubmissionModal";
import { SubmissionStatus, useWave } from "@/hooks/useWave";
interface MobileMemesArtSubmissionBtnProps {
  readonly wave: ApiWave;
}

/**
 * Floating button for mobile art submission in the top-right corner
 * Supports multiple states:
 * - Active: Green button when submissions are open and user can submit
 * - Disabled: Gray button when user can't submit (submissions ended, max reached, or not eligible)
 * - Urgent: Active button with animation when submission deadline is approaching
 */
const MobileMemesArtSubmissionBtn: React.FC<MobileMemesArtSubmissionBtnProps> = t0 => {
  const $ = _c(16);
  const {
    wave
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const waveInfo = useWave(wave);
  let t1;
  bb0: {
    if (!waveInfo) {
      t1 = false;
      break bb0;
    }
    t1 = waveInfo.participation.canSubmitNow === true;
  }
  const canSubmit = t1;
  let t2;
  bb1: {
    if (!waveInfo) {
      t2 = false;
      break bb1;
    }
    const now = Date.now();
    const endTime = waveInfo.participation.endTime;
    t2 = canSubmit && waveInfo.participation.isWithinPeriod && endTime && endTime - now < 21600000 && endTime - now > 0;
  }
  const isUrgent = t2;
  let t3;
  if ($[0] !== isUrgent || $[1] !== waveInfo) {
    t3 = () => {
      if (!waveInfo) {
        return "Submit Work to The Memes";
      }
      const status = waveInfo.participation.status;
      if (status === SubmissionStatus.ENDED) {
        return "Submissions are closed";
      }
      if (!waveInfo.participation.isEligible) {
        return "You are not eligible to submit to this wave";
      }
      if (waveInfo.participation.hasReachedLimit) {
        return "You have reached your maximum submissions";
      }
      return isUrgent ? "Submit Work to The Memes - Deadline approaching!" : "Submit Work to The Memes";
    };
    $[0] = isUrgent;
    $[1] = waveInfo;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const getAriaLabel = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(true);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = !canSubmit;
  const t6 = `tw-absolute tw-top-4 tw-right-4 tw-z-40 tw-text-white tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-rounded-full tw-size-10 tw-text-sm tw-font-semibold tw-shadow-sm focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-600 tw-transition tw-duration-300 tw-ease-out ${!canSubmit ? "tw-bg-gray-400 tw-border-gray-400 tw-cursor-not-allowed" : isUrgent ? "tw-bg-primary-600 tw-border-primary-600 tw-animate-pulse" : "tw-bg-primary-500 tw-border-primary-500 desktop-hover:hover:tw-bg-primary-600 desktop-hover:hover:tw-border-primary-600"}`;
  const t7 = getAriaLabel();
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg xmlns="http://www.w3.org/2000/svg" className="tw-size-6 tw-flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== t5 || $[6] !== t6 || $[7] !== t7) {
    t9 = <button onClick={t4} disabled={t5} className={t6} aria-label={t7}>{t8}</button>;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsOpen(false);
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== isOpen || $[11] !== wave) {
    t11 = <MemesArtSubmissionModal isOpen={isOpen} wave={wave} onClose={t10} />;
    $[10] = isOpen;
    $[11] = wave;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11 || $[14] !== t9) {
    t12 = <div className="lg:tw-hidden">{t9}{t11}</div>;
    $[13] = t11;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  return t12;
};
export default React.memo(MobileMemesArtSubmissionBtn);